import { type Archivable, type ArchivedFilter, type AuditProps } from '../model'
import { isEmpty } from './isEmpty'
import { getCreatedAt } from './audit'

export function filterArchived<T extends Archivable>(list?: T[], showArchived: ArchivedFilter = false): T[] {
  if (isEmpty(list)) return []
  if (showArchived === 'all') return list
  return list.filter((item) => {
    if (showArchived) return isDeleted(item)
    return isNotDeleted(item)
  })
}

export function isDeleted<T extends Archivable>(item: T | undefined): boolean {
  if (isEmpty(item)) return true
  return item.isDeleted === true
}

export function isNotDeleted<T extends Archivable>(item: T | undefined): item is T {
  return !isDeleted(item)
}

export function getLatestAuditItem<T extends AuditProps>(items: T[]): T | undefined {
  sortAuditItemsAscending(items)
  return items.at(-1)
}

export function getEarliestAuditItem<T extends AuditProps>(items: T[]): T | undefined {
  sortAuditItemsAscending(items)
  return items.at(0)
}

export function sortAuditItemsAscending(items: AuditProps[]): void {
  items.sort((a, b) => {
    const aDate = a.updatedAt ?? getCreatedAt(a) ?? 0
    const bDate = b.updatedAt ?? getCreatedAt(b) ?? 0
    return aDate - bDate
  })
}

export function sortAuditItemsDescending<T extends AuditProps>(items: T[]): T[] {
  return items.sort((a, b) => {
    const aDate = a.updatedAt ?? getCreatedAt(a) ?? Infinity
    const bDate = b.updatedAt ?? getCreatedAt(b) ?? Infinity
    return bDate - aDate
  })
}
